// extracted by mini-css-extract-plugin
module.exports = {"slider":"z6Iq1","vertical":"WSry9","dot":"H+KDm","dragging":"YYyRV","points":"mA-G2","orange":"_4E40-","point":"NEaNk","green":"ISBQa","red":"FMCl9","yellow":"bDloP"};